export interface IMetric {
  id: number;
  date: number;
  route: string;
  route_status: number;
  exe_time: number;
}

export interface IExpandedMetric extends IMetric {
  type: ERequestType;
  version?: string;
};

export enum ERequestType {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  HEAD = "HEAD",
  OPTIONS = "OPTIONS",
  CONNECT = "CONNECT",
  TRACE = "TRACE",
};